// @flow
import React from 'react'
import { imagePath } from 'frontend_core/dist/helpers/image'
import ErrorTemplate from 'components/templates/ErrorTemplate'
import { connect } from 'react-redux'
import { viewerFragment } from 'api/fragments'
import { wwwUrl } from 'frontend_core/dist/helpers/url'

function Container(props) {
  const title = i18n.t(`error.${props.status}.title` || 'error.default.title')
  const description =
    i18n.t(`error.${props.status}.description`) ||
    i18n.t('error.default.description')
  return (
    <ErrorTemplate {...props}>
      <div className="error">
        <div className="error__main page__stripes">
          <img
            src={imagePath('service/error/error_main-visual.png')}
            className="error__main-visual"
            role="presentation"
          />
          <h1 className="error__title">{title}</h1>
          <p className="error__message">{description}</p>
          <a href={wwwUrl('/')} className="button-stay-blue error__button">
            {i18n.t('page.error.buttonToTop')}
          </a>
        </div>
      </div>
    </ErrorTemplate>
  )
}

function mapStateToProps(state) {
  return state
}
export default connect(mapStateToProps)(Container)
